import React from 'react';
import PropTypes from 'prop-types';
import Links from '../../../../../components/Link';
import SocialSharing from '../../../../articleshow_v2/components/common/SocialWidget/SocialWidget';
import s from './SurveySuccess.scss';

const SurveySuccess = ({ isWapView, title, subtitle, path, wu }) => (
  <div className={s.successWrap}>
    <div className={s.sucImgWrap}>
      <img src="https://static.toiimg.com/photo/96537926.cms" alt="logo" />
    </div>
    <div className={s.sucTitle}>{title}</div>
    <div className={s.sucContent}>{subtitle}</div>
    <div className={s.shareBox}>
      <div className={s.shareTitle}>Share with Friends</div>
      <SocialSharing
        title="What are your expectations in the run up to Budget 2023? Take this TOI-Deloitte survey"
        url={wu}
        wu={wu}
        via="@timesofindia"
        isTablet
        whatsAppShow
        isWapView={isWapView}
        wrapperClass=""
        gaCategory="budget_survey"
        gaIndex="share_"
        gaAction="click_share"
        defaultEmailView
        disableShortUrl
      />
    </div>
    <div className={s.buttonWrap}>
      <Links
        className={s.button}
        to={wu}
        data={{
          gaAction: 'click',
          gaCategory: 'budget_survey',
          gaLabel: 'keep_browing_toi_cta',
        }}
      >
        TAKE ANOTHER SURVEY
      </Links>
      <Links
        className={s.button}
        to={path}
        data={{
          gaAction: 'click',
          gaCategory: 'budget_survey',
          gaLabel: 'keep_browing_toi_cta',
        }}
      >
        GO TO TOI
      </Links>
    </div>
  </div>
);

SurveySuccess.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  wu: PropTypes.string,
  path: PropTypes.string,
  isWapView: PropTypes.bool,
};

SurveySuccess.defaultProps = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  wu: PropTypes.string,
  path: PropTypes.string,
  isWapView: false,
};

export default React.memo(SurveySuccess);
